import {Style,Icon,Stroke} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON'; 
import { RoadNetwork_url ,featureName } from '../../Essentials/variables';

import { getLevel,getPreLevel } from '../../Essentials/common_fn';
import _ from "lodash";

const Road_config = {
    'Expressways' : {'type' : 'exp','layerName':'exp_road_network','outer_color':'rgba(0, 0, 0, 1)','inner_color' : 'rgba(255, 165, 0, 1)','outer_width' : 5,'inner_width' : 2},
    'National Highways' : {'type' : 'nhy','layerName' : 'nhy_road_network','outer_color':'rgba(0, 0, 0, 1)','inner_color' : 'rgba(255, 0, 0, 1)','outer_width' : 5,'inner_width' : 2},
    'State Highways' : {'type' : 'shy','layerName' : 'shy_road_network','outer_color':'rgba(0, 0, 0, 1)','inner_color' : 'rgba(223, 214, 18, 1)','outer_width' : 5,'inner_width' : 2},
    'District Roads' : {'type' : 'dhy','layerName' : 'dhy_road_network','outer_color':'rgba(0, 0, 0, 1)','inner_color' : 'rgba(255, 255, 255, 1)','outer_width' : 5,'inner_width' : 2},
    'Rural Roads' : {'type' : 'mvr','layerName' : 'mvr_road_network','outer_color':'rgba(0, 0, 0, 1)','inner_color' : 'rgba(0, 0, 0, 1)','outer_width' : 2,'inner_width' : 2},
    'Border Roads' : {'type' : 'brd','layerName' : 'brd_road_network','outer_color':'rgba(0, 0, 0, 1)','inner_color' : 'rgba(128,0,128,1)','outer_width' : 4,'inner_width' : 2}
}

let Token=localStorage.getItem('token')

//localhost:9000/roadnetworks/Gujarat/Ahmedabad/exp
function getUrl(stateName,DistrictName,SubDistrictName,type){
    var base_url = RoadNetwork_url;
    return base_url+ '/' + _.replace(stateName,/ /g, '') + '/' + _.replace(DistrictName,/ /g, '') + '/' + type;
}


export function getRoadLayer(selected,name){
    // console.log("selected",selected);
    let stateName = selected?.State;
    let DistrictName = selected?.District;
    let SubDistrictName=selected?.Sub_District;
    let type = Road_config[name]['type']
    // let url = getUrl(stateName,DistrictName,type);
    let vectorSource = new VectorSource({
        // url: url,
        loader: function(extent, resolution, projection, success, failure) {
            const proj = projection.getCode();
            const url = getUrl(stateName,DistrictName,SubDistrictName,type);
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.setRequestHeader('x-access-token',localStorage.getItem('token'));
            const onError = function() {
              vectorSource.removeLoadedExtent(extent);
              failure();
            }
            xhr.onerror = onError;
            xhr.onload = function() {
              if (xhr.status == 200) {
                const features = vectorSource.getFormat().readFeatures(xhr.responseText);
                vectorSource.addFeatures(features);
                success(features);
              } else {
                onError();
              }
            }
            xhr.send();
          },
        format: new TopoJSON({
            layers: [Road_config[name]['layerName']]
        }),
        overlaps: true,
    });


    vectorSource.on('featuresloadend',(evt)=>{
        let rvl_features = [];
        let level = getLevel(selected);
        evt.features.forEach((f)=>{
            if(_.isEmpty(selected.Village)){
                if(_.replace(f.get(featureName[getPreLevel(level)])," District","") !== selected[getPreLevel(level)]){
                    rvl_features.push(f);
                }
            }else{
                if(f.get(featureName[level]) !== selected[level]){
                    rvl_features.push(f);
                }
            }

        });
        rvl_features.forEach((f)=>{
            evt.target.removeFeature(f);
        });
});



    let style = [new Style({
        stroke: new Stroke({
          color: Road_config[name]['outer_color'],
          width: Road_config[name]['outer_width'],
        })
    }),
    new Style({
    stroke: new Stroke({
        color: Road_config[name]['inner_color'],
        width: Road_config[name]['inner_width'],
  })
})
];

    return new VectorLayer({
        source: vectorSource,
        style: style,
        visible: true,
        zIndex: 8
    });

}